import { useUserContext } from "@contexts/UserContext/index.context";
import { AccountCircle } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { UserRole } from "@types_def/models/user.type";
import { RoutePaths } from "@utils/constants/routes";

import { NavigationButton } from "../common/NavigationLink";

type Props = {};

function SideBar(_props: Props) {
  const { userState } = useUserContext();
  return (
    <Stack
      height="100%"
      width="100%"
      sx={{
        borderRight: "2px solid #f1f1f1",
      }}
      padding={2}
      gap={2}
    >
      <NavigationButton
        to={
          userState["custom:role"] === UserRole.ADMIN
            ? RoutePaths.adminProfileAccount
            : RoutePaths.clientProfileAccount
        }
        includes={RoutePaths.account}
      >
        <AccountCircle />
        <span style={{ fontSize: "0.75rem" }}>Account</span>
      </NavigationButton>
    </Stack>
  );
}

export default SideBar;
